<template>
    <div class="mb-0 mt-3 px-0 mx-0 w-100" style="max-width: none">
        <h5 v-if="(!vtc.providers)"
            class="text-center">
            Pour commencer à recevoir des mises à jour : ajouter des prestataires à votre veille.
        </h5>
        <h5 v-else-if="vtc.treated_diffs_count === 0" class="text-center">
            Vous n'avez aucune Mise à jour traitées
        </h5>
        <div class="row justify-content-evenly" v-else>
            <!--            liste des diffs en attente de traitement    -->
            <div class="col-6 w-100 border-right vtcDiffListBlock pt-0">
                <div class="sticky-top bg-white">
                    <div class="d-flex justify-content-between" v-if="vtc.treated_diffs_count > 0">
                        <!--                    filtre-->
                        <v-text-field @input="setNameToFilter" :value="treatedVtcDiffsSearchName"
                                      append-icon="mdi-magnify" label="Rechercher par nom"
                                      style="padding-top: 0 !important;"
                                      clearable class="mb-4 mr-4 mt-1" outlined hide-details>
                        </v-text-field>

                        <v-tooltip top v-if="treatedVtcDiffSortOrder === 'desc'">
                            <template v-slot:activator="{ on, attrs }">
                                <v-btn outlined class="custom-button-primary mt-1" style="height: 40px"
                                       @click="setTreatedVtcDiffSortOrder('asc')" v-on="on">
                                    <v-icon>arrow_downward</v-icon>
                                </v-btn>
                            </template>
                            <span>Trier par date croissante</span>
                        </v-tooltip>

                        <v-tooltip top v-if="treatedVtcDiffSortOrder === 'asc'">
                            <template v-slot:activator="{ on, attrs }">
                                <v-btn outlined class="custom-button-primary"
                                       @click="setTreatedVtcDiffSortOrder('desc')" v-on="on">
                                    <v-icon>arrow_upward</v-icon>
                                </v-btn>
                            </template>
                            <span>Trier par date décroissante</span>
                        </v-tooltip>
                    </div>
                </div>

                <div v-if="vtc.treated_diffs_count > 0 && treatedVtcDiffs.length === 0" class="text-center mt-4">
                    <h5>
                        Aucune mise à jour trouvé
                    </h5>
                </div>
                <div v-for="diff in treatedVtcDiffs" :key="diff.id" v-else
                     class="vtcDiffCard border rounded w-100 pr-3 mb-2 d-flex justify-content-between"
                     @click="selectDiff(diff)" :class="{'bg-light':selectedDiff && selectedDiff.id === diff.id}">
                    <div class="d-flex col-8">
                        <div class="d-flex flex-column mt-auto mb-auto ml-3">
                            <h5 class="text-primary">
                                {{ diff.provider_name }}
                            </h5>
                            <small class="font-italic">
                                {{ diff.provider_category }}
                            </small>
                        </div>
                    </div>

                    <div class="mt-auto mb-auto">
                        <span>
                            {{ formatDate(diff.date) }}
                        </span>
                        <v-icon color="light" v-if="diff.state.code === 'OT_REFUSED'">clear</v-icon>
                        <v-icon color="primary" v-else>check</v-icon>
                    </div>
                </div>
            </div>

            <!--    détail de la diff   -->
            <div class="col-6 w-100">
                    <p v-if="treatedVtcDiffs && treatedVtcDiffs.length >0 && selectedDiff === null" class="text-center">
                        Vous n'avez sélectionné aucune Mise à jour
                    </p>
                    <div v-else-if="treatedVtcDiffs && treatedVtcDiffs.length >0">
                        <div class="d-flex justify-content-between sticky-top bg-white border-bottom mr-2">
                            <router-link :to="'/summary/' + getB64(selectedDiff.provider_id)">
                                <h4>{{ selectedDiff.provider_name }}</h4>
                            </router-link>
                            <div class="d-flex">
                                <v-tooltip bottom v-if="selectedDiff.apidae_url">
                                    <template v-slot:activator="{ on }">
                                        <a :href="selectedDiff.apidae_url" target="_blank">
                                            <v-icon right color="blue" v-on="on">open_in_new</v-icon>
                                        </a>
                                    </template>
                                    <span>Voir sur Apidae</span>
                                </v-tooltip>
                            </div>
                        </div>

                        <div class="vtcDiffBlock px-2">
                            <div class="bg-light text-center mt-3">
                            <span>
                                {{ selectedDiff.last_ot_action.type.label }}
                              <span v-if="selectedDiff.last_ot_action.user">
                                par
                                {{ selectedDiff.last_ot_action.user.first_name }}
                                {{ selectedDiff.last_ot_action.user.last_name }}
                              </span>
                                 le
                                {{formatDate(selectedDiff.last_ot_action.created_at)}}
                            </span>
                            </div>
                            <sit-answer-diffs-step v-if="currentStep == 2 && selectedDiff" :languages="languages" :vt="true">
                            </sit-answer-diffs-step>
                        </div>

                        <div class="d-flex justify-content-between bg-white mt-2 pr-2">
                            <v-btn outlined class="custom-button-primary mr-2" @click="refuseVtcDiff">
                                <v-icon>clear</v-icon>
                                Refuser
                            </v-btn>
                            <v-btn outlined class="default-button" @click="sentToApidae"
                                   v-if="selectedDiff.diffs.length > 0">
                                <v-icon left>arrow_forward</v-icon>
                                Envoyer sur Apidae
                            </v-btn>
                        </div>
                    </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapState, mapMutations } from "vuex"
import SitAnswerDiffsStep from "../webform/sit-answer-steppers/SitAnswerDiffsStep.vue"
import _ from "lodash"

export default {
    name: "VtcHistory",
    components: { SitAnswerDiffsStep },
    props: {
        languages: {
            type: Array,
            default: () => [],
        },
    },
    data() {
        return {
            selectedDiff: null,
        }
    },
    methods: {
        ...mapMutations("sitAnswer", ["setDiffs"]),
        ...mapMutations("vtc", ["setTreatedVtcDiffsSearchName", 'setTreatedVtcDiffSortOrder']),
        selectDiff(diff) {
            this.selectedDiff = diff

            //set diff pour le component
            this.setDiffs(diff.diffs)
        },
        sentToApidae() {
            this.$global.loading = true
            let payload = {
                vtcDiffId: this.selectedDiff.id,
            }

            this.$http.post("/veille-tourisme/vtc/vtc-diff/write-apidae", payload).then((res) => {
                this.$global.loading = false
                if (res.body.success) {
                    this.selectedDiff = null
                }
                this.$global.$emit("reload-vtc", "2")
            })
        },
        getB64(id) {
            return btoa(id)
        },
        refuseVtcDiff() {
            this.$http.post("/veille-tourisme/vtc/vtc-diff/refuse/" + this.selectedDiff.id).then((res) => {
                this.$global.loading = false
                this.selectedDiff = null
                this.$global.$emit("reload-vtc", "2")
            })
        },
        setNameToFilter: _.debounce(function (value) {
            this.setTreatedVtcDiffsSearchName(value)
        }, 300),
    },
    computed: {
        ...mapState("vtc", [
            "vtc",
            "treatedVtcDiffs",
            'currentStep',
            'treatedVtcDiffsSearchName',
            'treatedVtcDiffSortOrder',
        ]),
    },
    watch: {
        currentStep() {
            if(this.currentStep == 2 && this.selectedDiff) {
                this.setDiffs(this.selectedDiff.diffs)
            }
        },
        treatedVtcDiffsSearchName() {
            this.selectedDiff = null
        }
    },
}
</script>